import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { BaseInputComponent } from '../base-input/base-input.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Language } from '../../../enum/language';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'languagepicker',
  templateUrl: './languagepicker.component.html',
  styleUrls: [ './languagepicker.component.scss' ],
  providers: [ {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => LanguagepickerComponent),
    multi: true
  } ]
})
export class LanguagepickerComponent extends BaseInputComponent implements OnInit {

  @Input() excludedLanguages$: BehaviorSubject<string[]> = null;
  @Input() showSelected = true;
  selectedLanguage?: { value: string, label: string };
  isOpen: boolean = false;
  languages: any[] = Object.keys(Language).map((lang: string) => {
    return {
      value: lang,
      label: Language[lang],
    };
  });
  options: any[];
  private addedLanguage: any;

  toggle(event: Event) {
    event.preventDefault();
    this.isOpen = !this.isOpen;
  }

  close() {
    this.isOpen = false;
  }

  onSelect(language) {
    if (this.showSelected) {
      this.selectedLanguage = language;
    }
    this.addedLanguage = language;
    this.form.controls[this.formControlName].setValue(language.value);
    this.close();
  }

  onChange() {
    if (!this.innerValue) {
      this.selectedLanguage = null;
    }
    this.resetOptions();
    super.onChange({ target: { value: this.selectedLanguage || this.addedLanguage } });
  }

  resetOptions() {
    if (!this.excludedLanguages$) {
      this.options = this.languages.filter(language => language !== this.selectedLanguage);
    }
  }

  ngOnInit(): void {
    if (this.excludedLanguages$) {
      this.excludedLanguages$.subscribe((excludedLanguages) => {
        this.options = this.languages.filter(language => language !== this.addedLanguage);
        this.options = this.options.filter(language => !excludedLanguages.includes(language.value));
      });
    }

    this.form.controls[this.formControlName].valueChanges.subscribe(() => this.onChange());
    this.resetOptions();
    super.ngOnInit();
  }
}
